import { useState } from "react";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";
import { BlTabs, TabType } from "Shared/BlTabs";
import { FilesTab } from "../Components/FilesTab/FilesTab";
import { SourcesTab } from "../Components/SourcesTab/SourcesTab";
import { ReleaseTab } from "../Components/ReleaseTab/ReleaseTab";

export const CodelistManagementPage: React.FunctionComponent = () => {
	const [activeTabID, setActiveTabID] = useState<number>(0);

	const tabs: TabType[] = [
		{
			tabID: 0,
			title: "Soubory",
			name: "files",
			child: <FilesTab />,
		},
		{
			tabID: 1,
			title: "Zdroje",
			name: "sources",
			child: <SourcesTab />,
		},
		{
			tabID: 2,
			title: "Import",
			name: "release",
			child: <ReleaseTab />,
		},
	];

	return (
		<AuthenticatedLayout title="Správa číselníků">
			<BlTabs
				activeTabID={activeTabID}
				tabs={tabs}
				onActiveTabChange={setActiveTabID}
			/>
		</AuthenticatedLayout>
	);
};
